var map = {
	"./1_Understanding_biologic_and_biosimilar_medicines.mp4": 1709,
	"./2_Biosimilar_manufacturing_considerations.mp4": 5802,
	"./3_Key_steps_of_a_biosimilar_development_program.mp4": 2332,
	"./4_Extrapolation_in_biosimilar_medicines.mp4": 9611,
	"./5_The_impact_of_multiple_sclerosis_on_the_healthcare_system.mp4": 2113,
	"./6_Biosimilar_medicines_and_the_healthcare_system.mp4": 4227,
	"./7_Biosimilar_treatment_switch_what_you_need_to_know.mp4": 8916,
	"./8_Unraveling_the_nocebo_effect_strategies_to_maximize_treatment_acceptability.mp4": 4011,
	"./poster.jpg": 6793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1366;